import { USER_INFO_GET_DONE, USER_INFO_GET_FAIL } from '../../action/userInfo';
import {
	LOGIN_DONE,
	LOGIN_FAIL,
	OTP_VERIFIATION_DONE,
	OTP_VERIFIATION_FAIL,
	SIGNUP_DONE,
	SIGNUP_FAIL,
} from '../../action/auth';

const initialState = {
	loading: false,
	userInfo: {},
	authToken: null,
	isAuthenticated: false,
	isOnboardingCompleted: true,
	error: '',
};

const userReducer = (state = initialState, action) => {
	switch (action.type) {
		case USER_INFO_GET_DONE:
			return {
				...state,
				loading: false,
				userInfo: action.payload,
				error: '',
			};
		case USER_INFO_GET_FAIL:
			return {
				...state,
				loading: false,
				userInfo: {},
				error: action.payload,
			};
		case LOGIN_DONE:
		case SIGNUP_DONE:
		case OTP_VERIFIATION_DONE:
			return {
				...state,
				loading: false,
				userInfo: action.payload?.data || action.payload, // Adjust based on actual payload structure
				authToken: action.payload?.token,
				isAuthenticated: true,
				error: '',
			};
		case LOGIN_FAIL:
		case SIGNUP_FAIL:
		case OTP_VERIFIATION_FAIL:
			return {
				...state,
				loading: false,
				userInfo: {},
				authToken: null,
				isAuthenticated: false,
				error: action.payload?.message || 'Authentication Failed',
			};
		case 'SET_ONBOARDING_COMPLETED':
			return {
				...state,
				isOnboardingCompleted: action.payload.isOnboardingCompleted,
			};
		case 'SET_AUTH_TOKEN':
			return {
				...state,
				authToken: action.payload.authToken,
			};
		case 'SET_CLEAR_USER_INFO':
			return {
				loading: false,
				userInfo: {},
				authToken: null,
				isAuthenticated: false,
				isOnboardingCompleted: true,
				error: '',
			};
		default:
			return state;
	}
};

export default userReducer;
